/*
    THIS FILE WAS DEVELOPED BY MEHMET GUDUK
    © 2022 COPYRIGHT, LICENSED WITH GPL-3.0 LICENSE, AUTHOR IS MEHMET GUDUK
    https://github.com/mehmetguduk
*/

import Card from "./components/Card";

export default function App() {
	return (
		<div className="App">
			<Card/>
		</div>
	);
}

